<section class="home">
  <div class="home-content">
    <picture>
      <!-- Desktop -->
      <source
        srcset="/logo_home-large2.webp 1x, /logo_home-large2@2x.webp 2x"
        media="(min-width: 768px)"
      />
      <!-- Mobile -->
      <source
        srcset="/logo_home-small2.webp 1x, /logo_home-small2@2x.webp 2x"
        media="(max-width: 767px)"
      />

      <!-- Fallback con prioridad -->
      <img
        src="/logo_home-small.webp"
        alt="Ana Pellón Mendoza - Psicóloga Sanitaria"
        class="home-logo"
        fetchpriority="high"
        decoding="async"
      />
    </picture>
    <h1 class="home-title">
      Ana Pellón Mendoza
      <span>Psicóloga sanitaria</span>
    </h1>
    <hr class="divider" />

    <a routerLink="/sobre-mi" class="btn-primary" appBottomTransitionReveal>Sobre mí</a>
  </div>
</section>
